import * as queries from 'query-string';

export function replaceSearchQuery<TQuery extends object>(query: TQuery) {
  return `?${queries.stringify(query, { arrayFormat: 'none', skipNull: true })}`;
}

export const mergeSearchQuery = <TQuery extends object>(uri: string, query: TQuery) => {
  const search = parseQueries<TQuery>(uri);
  return replaceSearchQuery({ ...search, ...query });
};

export const parseQueries = <T>(uri: string): T => {
  const query = queries.parse(uri, {
    arrayFormat: 'bracket',
    parseBooleans: true,
    parseNumbers: true,
  });
  for (const property in query) {
    if (query[property] === 'false') {
      query[property] = false;
    }
    if (query[property] === 'true') {
      query[property] = true;
    }
  }
  return query as T;
};

export const getJobState = (job_state: string, include_archived: boolean) => {
  switch (job_state) {
    case 'queued':
      return {
        job_state_id: 1,
        include_archived,
      };
    case 'starting':
      return {
        job_state_id: 2,
        include_archived,
      };
    case 'running':
      return {
        job_state_id: 3,
        include_archived,
      };
    case 'succeeded':
      return {
        job_state_id: 4,
        include_archived,
      };
    case 'stopped':
      return {
        job_state_id: 98,
        include_archived,
      };
    case 'failed':
      return {
        job_state_id: 99,
        include_archived,
      };
    case 'unarchived':
      return {
        job_state_id: null,
        include_archived: false,
      };
    case 'archived':
      return {
        job_state_id: null,
        include_archived: true,
      };
    default:
      return {
        job_state_id: null,
        include_archived,
      };
  }
};
